import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import rehypeSanitize, { defaultSchema } from "rehype-sanitize";
import styles from "./StaticContent.module.css";

const schema = {
  ...defaultSchema,
  attributes: {
    ...defaultSchema.attributes,
    img: [...(defaultSchema.attributes?.img ?? []), "src", "alt", "title"],
  },
};

type StaticContentProps = {
  content: string;
};

export const StaticContent = ({ content }: StaticContentProps) => {
  return (
    <article className={styles.container}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw, [rehypeSanitize, schema]]}>
        {content}
      </ReactMarkdown>
    </article>
  );
};
